module.exports = __webpack_public_path__ + "assets/img/2.50fde598.png";